import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Empty,
  Form,
  message,
  Row,
  Select,
  Spin,
} from "antd";
import debounce from 'lodash/debounce';
import { useState } from "react";
import {
  getCompanies,
  getProjects,
} from '../../../../services/general';
import CompanyModal from '../CompanyModal';
import ProjectModal from '../ProjectModal';

const SelectBox = ({
  sessionBranchOfficeId,
  handleOnChangeSearch,
  setter,
  list,
  formName,
  label,
  placeholder,
  field,
  buttonText,
  requireMessage,
  editButtonId,
  createButtonId,
  shouldUpdate,
  fetch,
  handleModalResult,
  form,
  createTitle,
  editTitle,
  setModal,
  lg,
  subLg = 22,
  formClassName,
  hideActions = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [companyModal, setCompanyModal] = useState({ type: 'create', visible: false });
  const [projectModal, setProjectModal] = useState({ type: 'create', visible: false });

  const fetchCompanies = debounce(async (text) => {
    if (sessionBranchOfficeId) {
      setLoading(true);
      try {
        const response = text ?
          await getCompanies({ query: text, branch_office_id: sessionBranchOfficeId })
          :
          { data: [] };
        setter(response.data);
      } catch (error) {
        console.error(error);
        message.error({
          content: 'Error al buscar la compañia',
          style: {
            marginTop: '45vh',
            fontSize: 16
          }
        });
      } finally {
        setLoading(false);
      }
    }
  }, 500);

  const fetchProjects = debounce(async (param) => {
    setLoading(true);
    try {
      const response = await getProjects({ query: param, company_id: form?.getFieldValue('company_id') });
      setter(response);
    } catch (error) {
      console.error(error);
      message.error({
        content: 'Error al buscar el proyecto',
        style: {
          marginTop: '45vh',
          fontSize: 16
        }
      });
    } finally {
      setLoading(false);
    }
  }, 500);

  const fetcher = {
    fetchCompanies,
    fetchProjects,
  }

  const setterModal = {
    setCompanyModal,
    setProjectModal,
  }

  const modal = {
    setCompanyModal: <CompanyModal
      addCompany={handleModalResult}
      reservationForm={form}
      companyModal={companyModal}
      setCompanyModal={setCompanyModal}
      formName={formName}
      createTitle={createTitle}
      editTitle={editTitle}
    />,
    setProjectModal: <ProjectModal
      handleModalResult={handleModalResult}
      setter={setter}
      externalForm={form}
      modal={projectModal}
      setModal={setProjectModal}
      formName={formName}
      createTitle={createTitle}
      editTitle={editTitle}
    />,
  }

  return (
    <Col lg={lg || 8} xs={24}>
      {modal[setModal]}
      <Spin className="cmt-spin" spinning={loading}>
        <Row>
          <Col lg={hideActions ? 24 : subLg} xs={hideActions ? 24 : subLg}>
            <Form.Item
              name={formName}
              label={label}
              rules={[{
                required: !!requireMessage,
                message: requireMessage
              }]}
              className={formClassName}
            >
              <Select
                className="cmt-select"
                placeholder={placeholder}
                showSearch
                showArrow={false}
                filterOption={false}
                allowClear
                onSearch={fetcher[fetch]}
                onChange={
                  (value, option) => handleOnChangeSearch && handleOnChangeSearch(field, value, option, setter)
                }
                onClear={(value, option) => handleOnChangeSearch && handleOnChangeSearch(field, value, option, setter)}
                notFoundContent={
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                      <div className="empty-search">
                        <div>No hay coincidencias</div>
                        {!hideActions && (
                          <div>
                            <Button
                              type="link"
                              onClick={() => setterModal[setModal]({
                                type: 'create',
                                visible: true
                              })}
                            >
                              {buttonText}
                            </Button>
                          </div>
                        )}
                      </div>
                    }
                  />
                }
              >
                {
                  list?.map(option =>
                    <Select.Option
                      key={option.id}
                      value={option.id}
                      company={option}
                    >
                      {option.business_name || option.name || option.document_number || option.id}
                    </Select.Option>
                  )
                }
              </Select>
            </Form.Item>
          </Col>
          {!hideActions && (
            <Col lg={24 - subLg} xs={24 - subLg} className='plus-button-container'>
              <Form.Item
                label="&nbsp;"
                shouldUpdate={shouldUpdate}
                className={formClassName}
              >
                {({ getFieldValue }) =>
                  getFieldValue(formName) ? (
                    <Button
                      block
                      onClick={() => setterModal[setModal]({
                        type: 'edit',
                        visible: true
                      })}
                      icon={<EditOutlined />}
                      id={editButtonId}
                    />
                  ) : (
                    <Button
                      block
                      onClick={() => setterModal[setModal]({
                        type: 'create',
                        visible: true
                      })}
                      icon={<PlusOutlined />}
                      id={createButtonId}
                    />
                  )
                }
              </Form.Item>
            </Col>
          )}
        </Row>
      </Spin>
    </Col>
  );
};

export default SelectBox;
